import { View, type ViewProps } from 'react-native';
import { StyleSheet, type UnistylesVariants } from 'react-native-unistyles';
import getOffsetColor from '@/utils/getOffsetColor';

type ComponentProps = UnistylesVariants<typeof style> & {
  color: string | undefined;
};

export default function BadgeMask({
  children,
  size,
  color = '#000',
}: ComponentProps & ViewProps) {
  style.useVariants({
    size,
  });

  return (
    <View style={style.container}>
      <View style={style.view(color)}>
        <View style={style.inner}>{children}</View>
      </View>
    </View>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    transform: [{ rotate: '45deg' }],
    variants: {
      size: {
        sm: {
          width: theme.size(8),
          height: theme.size(8),
        },
        md: {
          width: theme.size(10),
          height: theme.size(10),
        },
        lg: {
          width: theme.size(12),
          height: theme.size(12),
        },
        xl: {
          width: theme.size(16),
          height: theme.size(16),
        },
        '2xl': {
          width: theme.size(24),
          height: theme.size(24),
        },
      },
    },
  },
  view: (color: string) => ({
    alignItems: 'center',
    backgroundColor: color,
    borderColor: getOffsetColor(color, false),
    borderWidth: theme.size(1),
    justifyContent: 'center',
    overflow: 'hidden',
    position: 'absolute',
    variants: {
      size: {
        sm: {
          width: theme.size(8) / Math.sqrt(2),
          height: theme.size(8) / Math.sqrt(2),
          borderWidth: theme.size(0.25),
        },
        md: {
          width: theme.size(10) / Math.sqrt(2),
          height: theme.size(10) / Math.sqrt(2),
          borderWidth: theme.size(0.5),
        },
        lg: {
          width: theme.size(12) / Math.sqrt(2),
          height: theme.size(12) / Math.sqrt(2),
          borderWidth: theme.size(1),
        },
        xl: {
          width: theme.size(16) / Math.sqrt(2),
          height: theme.size(16) / Math.sqrt(2),
          borderWidth: theme.size(1),
        },
        '2xl': {
          width: theme.size(24) / Math.sqrt(2),
          height: theme.size(24) / Math.sqrt(2),
          borderWidth: theme.size(2),
        },
      },
    },
  }),
  inner: {
    transform: [{ rotate: '-45deg' }],
  },
}));
